import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Layers, RockBottomLayers} from "../view/RockBottomLayers";
import {RockBottom} from "../RockBottom";
import {RockBottomGameMode} from "../server/RockBottomGameMode";
import {RockBottomSound} from "../sound/RockBottomSound";
import {SpinePlayer} from "../../core/utils/SpinePlayer";
import {gsap, TweenLite} from "gsap";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {RockBottomGameAssets} from "../RockBottomGameAssets";
import {RockBottomXBetButton} from "../view/RockBottomXBetView";
import {RockBottomParsedInitData} from "../server/data/RockBottomParsedInitData";
import {RockBottomParsedGameData} from "../server/data/RockBottomParsedGameData";
import {RockBottomGameConfig} from "../RockBottomGameConfig";

export class WinCapScreen extends ContinueScreen {
    private _backgroundContainer: PIXI.Container;
    private finalWinOutroLevel1: SpinePlayer;
    private finalWinOutroLevel2: SpinePlayer;
    private finalWinOutroLevel3: SpinePlayer;
    private finalWinOutroLevel4: SpinePlayer;
    private finalWinOutroLevel5: SpinePlayer;
    private finalWinOutroLevel6: SpinePlayer;
    private eyeBlinkTransition: SpinePlayer;
    private _overlay: PIXI.Graphics;
    private eyeBlinkOverlayTop: PIXI.Graphics;
    private eyeBlinkOverlayBottom: PIXI.Graphics;
    private _overlay_Level2: PIXI.Graphics;
    private _winAmount: BitmapCountUp;
    private _finalMultiplier: BitmapCountUp;
    private _style: BitmapTextStyleOptions;
    private _styleMultiplier: BitmapTextStyleOptions;
    private _multiplier10xOutroPuddle: SpinePlayer;
    private _outroPage_Wall: SpinePlayer;
    private _isFromBonusGame: boolean = false;

    constructor() {
        super(RockBottomLayers.getLayer(Layers.SOFT_WIN_CAP_PICK)!);
        this.init();
        this.onResize();


        this._style = {
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 30,
            letterSpacing: -15
        };
        this._styleMultiplier = {
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 45,
            letterSpacing: -20,

        };
        this._winAmount = new BitmapCountUp(this._style);
        this._winAmount.shrinkSize = true;
        this._winAmount.maxTextWidth = 660;
        this._winAmount.position.set(360, 360);
        this._winAmount.pivot.set(this._winAmount.width / 2, this._winAmount.height / 2);

        this._finalMultiplier = new BitmapCountUp(this._styleMultiplier);
        this._finalMultiplier.shrinkSize = true;
        this._finalMultiplier.text = "19690x";
        this._finalMultiplier.shrinkSize = true;
        this._finalMultiplier.maxTextWidth = 450;
        if (!NolimitApplication.isLandscape) {
            this._finalMultiplier.position.set(360, 500);
        } else {
            this._finalMultiplier.position.set(360, 480);
        }
        this._finalMultiplier.visible = false;
        this._finalMultiplier.alpha = 0;
        this._container.addChild(this._winAmount, this._finalMultiplier);
    }

    public showAnimation(onContinueCallBack: () => void): void {
        //#231 fix
        RockBottom.pickAndClickView.hideView();
        RockBottom.background.updateBackGround(RockBottomGameMode.NORMAL);
        SlotGame.keypadPlugin.hide();
        const parsedInitData: RockBottomParsedInitData = RockBottom.model.parsedInitData,
            parsedGameData: RockBottomParsedGameData = RockBottom.model.parsedGameData;

        this._isFromBonusGame = RockBottom.inBonusGame ||
            ((parsedGameData.mode === RockBottomGameMode.WINCAP_PICK && RockBottom.model.parsedInitData.isRestoreState) &&
                (parsedInitData.mode === RockBottomGameMode.FREESPIN || parsedInitData.mode === RockBottomGameMode.SUPER_FREESPIN));

        let levelAnimationTl = gsap.timeline();
        this._finalMultiplier.visible = false;
        this._finalMultiplier.alpha = 0;

        RockBottomSound.fadeMusic(0, 0.1);
        if (parsedGameData.capWinMultiplier >= 2) {
            levelAnimationTl.add(this.finalWinOutroLevel1.play({
                name: "animation",
                showOnEnd: false,
                onStart: () => {
                    this.finalWinOutroLevel1.visible = true;
                    this._overlay.visible = true;
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WIN_CAP_FISH_DYING});
                },
            }));
            levelAnimationTl.add(this.finalWinOutroLevel2.play({
                name: "animation",
                showOnEnd: false,
                onStart: () => {
                    this._overlay.visible = true;
                    this.finalWinOutroLevel1.visible = false;
                    this.finalWinOutroLevel2.visible = true;
                    this._overlay_Level2.visible = true;
                    this._winAmount.alpha = 1;
                    this._winAmount.visible = true;
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WIN_CAP_FLUSH});
                },
            }));
            levelAnimationTl.add(() => {
                this._winAmount.getCountUpAnimation(0.00, 1969 * parsedGameData.playedBetValue, 3, 'power3.inOut')
            }, "-=2");
            levelAnimationTl.add(this.finalWinOutroLevel3.play({
                name: "Idle",
                showOnEnd: false,
                onStart: () => {
                    this._overlay.visible = false;
                    this.finalWinOutroLevel2.visible = false;
                    this._overlay_Level2.visible = false;
                    this.finalWinOutroLevel3.visible = true;
                    this.eyeBlinkOverlayTop.visible = true;
                    this.eyeBlinkOverlayBottom.visible = true;
                    this.eyeBlinkTransition.play({name: "blink", loop: false, showOnEnd: false});
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WIN_CAP_LEVEL_1});
                },
                onComplete: () => {
                    this.finalWinOutroLevel3.visible = false;
                }
            }));
            levelAnimationTl.add(() => {
                this._winAmount.getCountUpAnimation(1969 * parsedGameData.playedBetValue, 1969 * parsedGameData.playedBetValue * 2, 3.8, 'power3.inOut')
            }, "-=3.8");
            levelAnimationTl.add(() => {
                TweenLite.to(this._winAmount.position, {
                    duration: 3,
                    y: 510,
                })
            }, "-=3.8");
        }
        if (parsedGameData.capWinMultiplier >= 3) {
            levelAnimationTl.add(this.finalWinOutroLevel4.play({
                name: "Idle",
                showOnEnd: false,
                onStart: () => {
                    this.finalWinOutroLevel4.visible = true;
                    this.eyeBlinkTransition.play({name: "blink", loop: false, showOnEnd: false});
                    RockBottomSound.playTrack(RockBottomSound.WIN_CAP_LEVEL_2);
                },
                onComplete: () => {
                    this.finalWinOutroLevel4.visible = false;
                }
            }));
            levelAnimationTl.add(() => {
                this._winAmount.getCountUpAnimation(1969 * parsedGameData.playedBetValue * 2, 1969 * parsedGameData.playedBetValue * 3, 3.8, 'power3.inOut')
            }, "-=3.8");
        }
        if (parsedGameData.capWinMultiplier >= 5) {
            levelAnimationTl.add(this.finalWinOutroLevel5.play({
                name: "Idle",
                showOnEnd: false,
                onStart: () => {
                    this.finalWinOutroLevel5.visible = true;
                    this.eyeBlinkTransition.play({name: "blink", loop: false, showOnEnd: false});
                    RockBottomSound.playTrack(RockBottomSound.WIN_CAP_LEVEL_3);
                },
                onComplete: () => {
                    this.finalWinOutroLevel5.visible = false;
                }
            }));
            levelAnimationTl.add(() => {
                this._winAmount.getCountUpAnimation(1969 * parsedGameData.playedBetValue * 3, 1969 * parsedGameData.playedBetValue * 5, 3.8, 'power3.inOut')
            }, "-=3.8");
        }
        if (parsedGameData.capWinMultiplier >= 7) {
            levelAnimationTl.add(this.finalWinOutroLevel6.play({
                name: "Idle",
                showOnEnd: false,
                onStart: () => {
                    this.eyeBlinkTransition.visible = false;
                    this.finalWinOutroLevel6.visible = true;
                    this.eyeBlinkTransition.play({name: "blink", loop: false, showOnEnd: false});
                    RockBottomSound.playTrack(RockBottomSound.WIN_CAP_LEVEL_4);
                },
                onComplete: () => {
                    this.finalWinOutroLevel6.visible = false;
                }
            }));
            levelAnimationTl.add(() => {
                this._winAmount.getCountUpAnimation(1969 * parsedGameData.playedBetValue * 5, 1969 * parsedGameData.playedBetValue * 7, 3.8, 'power3.inOut')
            }, "-=3.8");
        }

        levelAnimationTl.add(() => {
            this.setOutroPage();
            if (parsedGameData.capWinMultiplier > 7) {
                this._winAmount.getCountUpAnimation(1969 * parsedGameData.playedBetValue * 7, 1969 * parsedGameData.playedBetValue * 10, 3.8, 'power3.inOut').eventCallback("onComplete", () => {
                    this.enableContinueButton();
                });
            } else {
                this.enableContinueButton();
            }

        });

        levelAnimationTl.play();
        this.show(onContinueCallBack);
    }

    //overriding show method
    public show(onContinueCallBack: () => void): void {
        this.visible = true;
        this._continueCallback = onContinueCallBack;
        if (RockBottom.isBoostedBetAllowed()) {
            RockBottom.xBetView.toggleXBetFlushAnim(true, true);
            const xBetBtn: RockBottomXBetButton = RockBottom.xBetView.getXBetButton();
            xBetBtn.switchOnBonusGame(true);
        }
    }

    public onOrientationChanged() {
        super.onOrientationChanged();
    }

    protected close(): TimelineLite {
        const parsedGameData: RockBottomParsedGameData = RockBottom.model.parsedGameData;
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(
            () => {
                RockBottomGameConfig.resetVariablesForWinCap();
                RockBottom.pickAndClickView.toggleVisibility(false);
                this.finalWinOutroLevel1.stop();
                this.finalWinOutroLevel2.stop();
                this.finalWinOutroLevel3.stop();
                this.finalWinOutroLevel4.stop();
                this.finalWinOutroLevel5.stop();
                this.finalWinOutroLevel6.stop();

                this._finalMultiplier.alpha = 0;
                this._finalMultiplier.visible = false;
                this._isFromBonusGame = false;
                this._outroPage_Wall.stop();
                this._outroPage_Wall.visible = false;
                gsap.to([this._overlay, this._winAmount], {
                    duration: 0.5,
                    alpha: 0,
                    onComplete: () => {
                        this._overlay.visible = false;
                        this._overlay.alpha = 1;
                        this._winAmount.visible = false;
                        this._winAmount.text = "";
                        this._winAmount.position.set(360);
                    }
                });
                RockBottom.setBonusMode(false);
                RockBottomSound.soundPlayer.stopTrack(RockBottomSound.WIN_CAP_LEVEL_6);
                if (parsedGameData.capWinMultiplier === 2 || parsedGameData.capWinMultiplier === 3) {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WINCAP_END_CONTINUE_SOUND});
                } else if (parsedGameData.capWinMultiplier === 5) {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WINCAP_END_CONTINUE_LEVEL3_SOUND});
                } else if (parsedGameData.capWinMultiplier === 7) {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WINCAP_END_CONTINUE_LEVEL4_SOUND});
                } else if (parsedGameData.capWinMultiplier === 10) {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.WINCAP_END_CONTINUE_LEVEL5_SOUND});
                }
                RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.getMusicNameByMode(RockBottomGameMode.NORMAL)});
            }
        );
        if (parsedGameData.capWinMultiplier === 10) {
            this._continueButton.visible = false;
            this._continueButton.enable(false);
            const headBudDur: number = this._multiplier10xOutroPuddle.fetchDuration("Head_bud");
            tl.to(this, {
                duration: headBudDur,
                onStart: () => {
                    this._multiplier10xOutroPuddle.play({
                        name: "Head_bud"
                    });
                }
            });

            const textAnimDur: number = this._multiplier10xOutroPuddle.fetchDuration("Text");
            tl.to(this, {
                duration: textAnimDur,
                onStart: () => {
                    this._multiplier10xOutroPuddle.play({
                        name: "Text"
                    });
                }
            });

            tl.add(() => {
                this.eyeBlinkOverlayTop.visible = false;
                this.eyeBlinkOverlayBottom.visible = false;
                this.eyeBlinkTransition.stop();
                this.eyeBlinkTransition.visible = false;
                this._multiplier10xOutroPuddle.stop();
                super.close();
            });

            tl.to(this, {duration: 0.5});
        }
        else {
            tl.add(this.eyeBlinkTransition.play({
                name: "blink",
                loop: false,
                showOnEnd: false,
            }));

            tl.add(() => {
                this.eyeBlinkOverlayTop.visible = false;
                this.eyeBlinkOverlayBottom.visible = false;
                this.eyeBlinkTransition.stop();
                this.eyeBlinkTransition.visible = false;
            }, "-=3");

            tl.add(() => {
                super.close()
            }, 0);
        }
        return tl;
    }

    private init(): void {
        this._backgroundContainer = new PIXI.Container();
        this._backgroundContainer.position.set(360, 350);
        this.createOverlay();
        this.finalWinOutroLevel2 = new SpinePlayer("SoftWin_level2", false);
        this.finalWinOutroLevel2.name = "SoftWinLevel2";
        this.finalWinOutroLevel2.position.set(0, 5);
        this.finalWinOutroLevel1 = new SpinePlayer("SoftWin_level1", false);
        this.finalWinOutroLevel1.name = "SoftWinLevel1";
        this.finalWinOutroLevel1.position.set(0, 5);
        this.finalWinOutroLevel3 = new SpinePlayer("SW_Level_3_M5", false);
        this.finalWinOutroLevel3.name = "SoftWinLevel_3_M5";
        this.finalWinOutroLevel3.position.set(50, -50);
        this.finalWinOutroLevel4 = new SpinePlayer("SW_Level_3_M4", false);
        this.finalWinOutroLevel4.name = "SoftWinLevel_3_M4";
        this.finalWinOutroLevel4.position.set(50, -50);
        this.finalWinOutroLevel5 = new SpinePlayer("SW_Level_3_M3", false);
        this.finalWinOutroLevel5.name = "SoftWinLevel_3_M3";
        this.finalWinOutroLevel5.position.set(50, -50);
        this.finalWinOutroLevel6 = new SpinePlayer("SW_Level_3_M2", false);
        this.finalWinOutroLevel6.name = "SoftWinLevel_3_M2";
        this.finalWinOutroLevel6.position.set(50, -50);
        this.eyeBlinkTransition = new SpinePlayer("Eyeblink", false);
        this.eyeBlinkTransition.name = "eyeBlink";
        this.eyeBlinkTransition.position.set(0, 15);
        this.eyeBlinkTransition.scale.set(1.1, 1.1);
        this.eyeBlinkOverlayTop = new PIXI.Graphics;
        this.eyeBlinkOverlayTop.visible = false;
        this.eyeBlinkOverlayTop.position.set(-360, -400);
        this._overlay_Level2 = new PIXI.Graphics;
        this._overlay_Level2.visible = false;
        this._overlay_Level2.position.set(-360, 0);
        this.eyeBlinkOverlayBottom = new PIXI.Graphics;
        this.eyeBlinkOverlayBottom.visible = false;
        this.eyeBlinkOverlayBottom.position.set(-360, -615);
        this._backgroundContainer.addChild(this.finalWinOutroLevel1, this.finalWinOutroLevel2, this._overlay_Level2, this.finalWinOutroLevel3, this.finalWinOutroLevel4, this.finalWinOutroLevel5, this.finalWinOutroLevel6);
        this._backgroundContainer.addChild(this.eyeBlinkTransition, this.eyeBlinkOverlayTop, this.eyeBlinkOverlayBottom);
        this.loadLastImage();
        this._container.addChild(this._backgroundContainer);
    }

    private loadLastImage(): void {
        this._outroPage_Wall = new SpinePlayer("SW_Level_05", false);
        this._outroPage_Wall.position.set(50, -50);
        this._multiplier10xOutroPuddle = new SpinePlayer("SW_Level_X10", false);
        this._multiplier10xOutroPuddle.position.set(0);
        this._backgroundContainer.addChild(this._outroPage_Wall, this._multiplier10xOutroPuddle);
    }

    private setOutroPage(): void {
        RockBottomSound.soundPlayer.playTrack({
            name: RockBottomSound.WIN_CAP_LEVEL_6,
            repeat: Number.MAX_VALUE
        });
        this._outroPage_Wall.visible = true;
        const parsedData = RockBottom.model.parsedGameData;
        let animName: string;
        if (parsedData.capWinMultiplier === 2) {
            animName = "X2";
            this._outroPage_Wall.play({name: animName, showOnEnd: true});
        } else if (parsedData.capWinMultiplier === 3) {
            animName = "X3";
            this._outroPage_Wall.play({name: animName, showOnEnd: true});
        } else if (parsedData.capWinMultiplier === 5) {
            animName = "X5";
            this._outroPage_Wall.play({name: animName, showOnEnd: true});
        } else if (parsedData.capWinMultiplier === 7) {
            animName = "X7";
            this._outroPage_Wall.play({name: animName, showOnEnd: true});
        } else if (parsedData.capWinMultiplier === 10) {
            this._multiplier10xOutroPuddle.alpha = 1;
            this._multiplier10xOutroPuddle.play({
                name: "Cry", showOnEnd: false,
                onComplete: () => {
                    this._multiplier10xOutroPuddle.play({name: "Cry_loop", loop: true});
                }
            });
            this._outroPage_Wall.visible = false;
            this._multiplier10xOutroPuddle.visible = true;
        }
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Graphics;
        this._overlay.visible = false;
        this._container.addChild(this._overlay);
    }

    private enableContinueButton(): void {
        const parsedGameData: RockBottomParsedGameData = RockBottom.model.parsedGameData,
            tlDur: number = (parsedGameData.capWinMultiplier === 10) ? 1 : 0.3;

        TweenLite.to(this, {
            duration: tlDur,
            onComplete: () => {
                this._continueButton.visible = true;
                this._continueButton.enable(true);
                RockBottom.keypadPlugin.setWin(parsedGameData.totalWin, this._isFromBonusGame, BelowStakeWinRestriction.isWinBelowStake());

                if (parsedGameData.capWinMultiplier === 10) {
                    this._winAmount.visible = false;
                    this._winAmount.alpha = 0;
                    this._finalMultiplier.visible = true;
                    this._finalMultiplier.alpha = 1;
                }
            }
        });
    }

    private onResize(): void {
        if (this._overlay) {
            this._overlay.clear();
            this._overlay.beginFill(0x000000, 1);
            this._overlay.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height);
            this._overlay.endFill();
        }
        if (this.eyeBlinkOverlayTop) {
            this.eyeBlinkOverlayTop.clear();
            this.eyeBlinkOverlayTop.beginFill(0x000000, 1);
            this.eyeBlinkOverlayTop.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height / 4);
            this.eyeBlinkOverlayTop.endFill();
            if (NolimitApplication.isLandscape) {
                this.eyeBlinkOverlayTop.alpha = 0;
            } else {
                this.eyeBlinkOverlayTop.alpha = 1;
                if (RockBottom.isIpad) {
                    this.eyeBlinkOverlayTop.position.set(-360, -500);
                }
            }

        }
        if (this._overlay_Level2) {
            this._overlay_Level2.clear();
            this._overlay_Level2.beginFill(0x000000, 1);
            this._overlay_Level2.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.center, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height / 2);
            this._overlay_Level2.endFill();
        }
        if (this.eyeBlinkOverlayBottom) {
            this.eyeBlinkOverlayBottom.clear();
            this.eyeBlinkOverlayBottom.beginFill(0x000000, 1);
            this.eyeBlinkOverlayBottom.drawRect(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.bottom, NolimitApplication.screenBounds.width, NolimitApplication.screenBounds.height / 4);
            this.eyeBlinkOverlayBottom.endFill();
            if (NolimitApplication.isLandscape) {
                this.eyeBlinkOverlayBottom.alpha = 0;
            } else {
                this.eyeBlinkOverlayBottom.alpha = 1;
                if (RockBottom.isIpad) {
                    this.eyeBlinkOverlayBottom.position.set(-360, -470);
                } else {
                    this.eyeBlinkOverlayBottom.position.set(-360, -615);
                }
            }
        }

        if (this._finalMultiplier) {
            if (!NolimitApplication.isLandscape) {
                this._finalMultiplier.position.set(360, 500);
            } else {
                this._finalMultiplier.position.set(360, 480);
            }
        }
        this.onOrientationChanged();
    }
}